const sourceFieldName = 'hidden-1';
const missingFields = new WeakSet();

function setContactSource(form) {
  const container = form.closest('[data-contact-form-source]');
  if (!container || !form.matches('.forminator-custom-form')) return;

  const field = form.querySelector(`input[name="${sourceFieldName}"]`);
  if (!field) {
    if (!missingFields.has(form)) {
      console.warn(`Contact form is missing the Forminator source field ${sourceFieldName}.`);
      missingFields.add(form);
    }
    return;
  }

  const source = container.dataset.contactFormSource;
  if (field.value !== source) {
    field.value = source;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

function syncForms(node) {
  if (!(node instanceof Element)) return;

  if (node.matches('form.forminator-custom-form')) setContactSource(node);
  node.querySelectorAll('form.forminator-custom-form').forEach(setContactSource);
  if (node.matches(`input[name="${sourceFieldName}"]`)) {
    const form = node.closest('form.forminator-custom-form');
    if (form) setContactSource(form);
  }
}

if (typeof document !== 'undefined') {
  syncForms(document.body);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(syncForms);
    });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) setContactSource(event.target);
  }, true);

  document.addEventListener('click', (event) => {
    const submit = event.target instanceof Element
      ? event.target.closest('form.forminator-custom-form .forminator-button-submit, form.forminator-custom-form button[type="submit"], form.forminator-custom-form input[type="submit"]')
      : null;
    if (submit) setContactSource(submit.form);
  }, true);
}
